import { useQuery } from '@tanstack/react-query';
import type { AuthConfigDto } from '@orienta/shared';
import { api } from '@/lib/api';

/** Recursos públicos de acesso habilitados no servidor (cadastro aberto, link mágico). */
export function useAuthConfig() {
  return useQuery({
    queryKey: ['auth', 'config'],
    queryFn: () => api<AuthConfigDto>('/auth/config', { skipAuthRedirect: true }),
    staleTime: 10 * 60_000,
  });
}
